export const caretIconWidth = 10;
export const defaultColumnWidth = 80;
export const footerHeight = 50;
export const gapBarContainerWidth = 100;
export const gapBarHeight = 30;
export const musicFileIconWidth = 24;
export const rowHeight = 50;
export const subRowHeight = 50;
export const tableHeight = 350;
export const summarizeRowsAbove = 1;

export const COLUMN_IDS = {
    WORK_NAME: 'workName',
    DETECTIONS: 'detections',
    ESTIMATED_LOSS: 'estimatedLoss',
    GAP: 'gap',
    INCLUDE_AUDIO_FILE: 'includeAudioFile',
    PERFORMANCES: 'performances',
    STATEMENT_WORK: 'statementWork',
    SURVEY_TYPE: 'surveyType',
    USE_CODE: 'useCode',
};
